import { render, staticRenderFns } from "./ui-time.vue?vue&type=template&id=b903b2cc&scoped=true"
import script from "./ui-time.vue?vue&type=script&lang=js"
export * from "./ui-time.vue?vue&type=script&lang=js"
import style0 from "./ui-time.vue?vue&type=style&index=0&id=b903b2cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b903b2cc",
  null
  
)

export default component.exports